<template> </template>

<script>
  import auth from "@/auth/authService";
  export default {
    name: "Logout",
    mounted() {
      // console.log(window.$cookies.remove('companyId', Infinity));
      this.$store
        .dispatch("auth/logout")
        .then(res => {
          console.log("logout successful", res);
          // auth.logOut();
          if(window.$cookies.get('companyId')){
            window.$cookies.remove('companyId');
            window.$cookies.remove('companyName');
            window.$cookies.remove('enterpriseType');
            localStorage.removeItem('themeColor')
          }
          window.$cookies.remove('companyName');
          window.$cookies.remove('organizationType');
          window.$cookies.remove('terminology');

          window.$cookies.remove('firstName');
          localStorage.removeItem('accessToken')
          localStorage.removeItem('feathers-jwt')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('themeColor')
        //  localStorage.removeItem('secondaryColor')
          this.$router.push({name: 'user-login'})
        })
        .catch(err => {
          console.log("error logging out", err);
        });
    }
  };
</script>

<style scoped></style>
